import { render, staticRenderFns } from "./blocking_issues_count.vue?vue&type=template&id=3ec71242"
import script from "./blocking_issues_count.vue?vue&type=script&lang=js"
export * from "./blocking_issues_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports